module.exports = __webpack_public_path__ + "img/workout.80d3e5bd.svg";